module.exports = __webpack_public_path__ + "static/media/kingston-logo.60e22369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/kingston-logo.png
// module id = 405
// module chunks = 1